/**
 * Covermatic Studio modal coordinator.
 */
(() => {
  const runtime = window.CovermaticRuntime || window.AlphaRuntime || {};
  window.CovermaticRuntime = runtime;
  window.AlphaRuntime = runtime;
  const { Utils, Events, TemplateBrowserController, ImageViewerController, PurchaseModalController } = runtime;

  class ModalController {
    constructor() {
      this.templateBrowser = new TemplateBrowserController(this);
      this.imageViewer = new ImageViewerController(this);
      this.purchaseModal = new PurchaseModalController(this);

      this.init();
    }

    init() {
      document.addEventListener('click', (event) => {
        if (event.target.dataset.close === 'overlay' || event.target.closest('[data-close="x"]')) {
          if (event.target.closest('#studio-modal')) this.closeStudioModal();
          if (event.target.closest('#tpl-modal')) this.closeTemplateModal();
          if (event.target.closest('#modal')) this.closeImageModal();
          if (event.target.closest('#buy-modal')) this.closeBuyModal();
          if (event.target.closest('#promo-graphics-modal')) this.closePromoGraphicsModal();
          if (event.target.closest('#creative-lab-assets-modal')) this.closeCreativeLabAssetsModal();
          return;
        }

        const promoChoice = event.target.closest('[data-promo-graphic-choice]');
        if (promoChoice) {
          event.preventDefault();
          Events.emit('promo-graphics:direction-selected', {
            type: promoChoice.dataset.promoGraphicChoice || 'custom',
            label: promoChoice.dataset.promoLabel || 'Promo Graphic',
            size: promoChoice.dataset.promoSize || 'square_1_1',
            image: promoChoice.dataset.promoImage || '',
            brief: promoChoice.dataset.promoBrief || '',
            copy: promoChoice.querySelector('p')?.textContent?.trim() || '',
          });
          this.closePromoGraphicsModal();
          return;
        }

        if (this.purchaseModal.handleDocumentClick(event)) return;
        if (this.imageViewer.handleDocumentClick(event)) return;
        this.templateBrowser.handleDocumentClick(event);
      });
    }

    openStudioModal(...args) { return this.templateBrowser.openStudioModal(...args); }
    closeStudioModal(...args) { return this.templateBrowser.closeStudioModal(...args); }
    openTemplateModal(...args) { return this.templateBrowser.openTemplateModal(...args); }
    closeTemplateModal(...args) { return this.templateBrowser.closeTemplateModal(...args); }
    preloadSignatureStyles(...args) { return this.templateBrowser.preloadSignatureStyles(...args); }
    selectSignatureStyleAsset(...args) { return this.templateBrowser.selectSignatureStyleAsset(...args); }
    selectSignatureStyle(...args) { return this.templateBrowser.selectSignatureStyle(...args); }
    selectTemplate(...args) { return this.templateBrowser.selectTemplate(...args); }
    openImage(...args) { return this.imageViewer.openImage(...args); }
    closeImageModal(...args) { return this.imageViewer.closeImageModal(...args); }
    openBuyModal(...args) { return this.purchaseModal.openBuyModal(...args); }
    closeBuyModal(...args) { return this.purchaseModal.closeBuyModal(...args); }
    openPromoGraphicsModal() {
      const modal = Utils.$('promoGraphicsModal');
      if (!modal) return;
      modal.classList.remove('hidden');
      Utils.syncBodyLock();
    }
    closePromoGraphicsModal() {
      const modal = Utils.$('promoGraphicsModal');
      if (!modal) return;
      modal.classList.add('hidden');
      Utils.syncBodyLock();
    }
    closeCreativeLabAssetsModal() {
      const modal = Utils.$('creativeLabAssetsModal');
      if (!modal) return;
      modal.classList.add('hidden');
      Utils.syncBodyLock();
    }
    selectPack(...args) { return this.purchaseModal.selectPack(...args); }
  }

  runtime.ModalController = ModalController;
})();
